@if (app.smallScreen) {
    <p class="note">Models can't be changed on a small touch screen. You can view models and insights here, and switch to a laptop or desktop to model.</p>
}
@if (organisationRows.length === 0) {
    <p class="note">No organisations match.</p>
}@else {
    <app-table [columns]="columns" [data]="organisationRows" [filter]="true" [rowSelect]="true" [height]="getTableHeight()" (rowEvent)="handleRowEvent($event)"></app-table>
}
